import { USD_DECIMALS } from '@ui/constants/numbersDecimals';
import { FormatBigValueOptions } from '@ui/lib/bignumber';
import { TextProps } from '@ui/lib/park/ui/text';

import { BigIntAmount } from './BigIntAmount';

export type BigIntAmountUsdProps = TextProps & {
  value?: bigint;
  opts?: Partial<FormatBigValueOptions>;
};

export const BigIntAmountUsd: React.FC<BigIntAmountUsdProps> = ({
  value,
  opts,
  ...props
}) => {
  return (
    <BigIntAmount
      {...props}
      value={value}
      opts={{
        decimals: USD_DECIMALS,
        prefix: '$',
        ...opts,
      }}
    />
  );
};
